
// entry can be a plain string or { key, sections }
const getSettingsKey = (entry) => entry?.key ?? entry

const transferSettings = (originalObject, getSettingsData, settingTypes) => {
    try {
        let enrichedData = { ...originalObject }

        for (const entry of settingTypes) {
            const settingType = getSettingsKey(entry)
            const allowedSections = entry?.sections ?? null

            const settingsObject = getSettingsData(settingType)
            if (!settingsObject) continue

            const config = getModel('transferSettingsData')[settingType]
            if (!config) continue

            // Transfer section data, filtered by allowedSections when specified
            for (const sectionKey in config) {
                if (sectionKey === 'root') continue
                if (allowedSections && !allowedSections.includes(sectionKey)) continue

                const section = config[sectionKey];
                if (Array.isArray(section)) {
                    section.forEach(key => {
                        if (settingsObject[key]) {
                            enrichedData[sectionKey] = enrichedData[sectionKey] || {};
                            enrichedData[sectionKey][key] = JSON.parse(JSON.stringify(settingsObject[key]));
                        }
                    });
                }
            }

            // Transfer root data when not filtered out
            if (!allowedSections || allowedSections.includes('root')) {
                const root = config.root || {};
                Object.keys(root).forEach(key => {
                    const dataKey = root[key];
                    if (!enrichedData.hasOwnProperty(key) && settingsObject[dataKey]) {
                        enrichedData[key] = settingsObject[dataKey];
                    }
                });
            }
        }

        return enrichedData;
    } catch (error) {
        console.error('Error transferring settings:', error);
        throw error;
    }
}

export { getSettingsKey }

export default transferSettingsimport { getModel } from '../../model/registry'

